import axios from 'axios'
import getActiveProgram from '../utils/getActiveProgram'
import getTimeZone from '../utils/getTimeZone'

export default (date) => {
	axios
		.post(`/schedule/${date}`)
		.then((r) => {
			const {
				data: { schedule },
			} = r
			const findList = document.querySelector('#scheduleList')

			findList.innerHTML = ''
			let resultList = ''

			schedule
				.sort((a, b) => a.viewOrder - b.viewOrder)
				.forEach((sh) => {
					const template = document.querySelector('.templateCalendar').cloneNode(true)

					template.classList.remove('hidden')
					template.querySelector('.time').innerHTML = sh.time
					template.querySelector('.time').dataset['realtime'] = sh.time
					template.querySelector('.title').innerHTML = sh.telecast.title
					template.querySelector('.age').innerHTML = `(${sh.telecast.ageRating}+)`

					resultList += template.innerHTML
				})

			return (findList.innerHTML = resultList)
		})
		.then(() => {
			const tabDate = new Date(date).getDate()
			const currentDate = new Date().getDate()

			if (tabDate === currentDate) {
				getActiveProgram()
			}

			return
		})
		.then(() => getTimeZone())
		.catch((err) => console.log(err, 'err'))
}
